import React, { Component } from 'react';
import { TweenLite, TimelineLite } from 'gsap';
import Slider from 'react-slick';

import PlaylistButton from '../global/playlist/PlaylistButton';
import PlaylistGesturalNavigation from '../global/playlist/PlaylistGesturalNavigation';
import PlaylistVideo from '../global/playlist/PlaylistVideo';
import StoryProgressBar from '../global/playlist/StoryProgressBar';
import ArrowButton from '../ui/ArrowButton';
import PlaylistCoverText from './PlaylistCoverText';
import BackToChapterButton from './BackToChapterButton';
import ImageSlider from '../PixiPressPlay/ImageSlider';
import style from './ChapterSectionPressPlay.module.scss';
import SwipeNextPrev from '../ui/SwipeNextPrev';

const holdTimer = 1500;
let SplitText;
let DrawSVG;

const findButton = node => {
  if (node.classList.contains('playlist-button')) {
    return node;
  } else {
    return findButton(node.parentNode);
  }
};

class ChapterSectionPressPlay extends Component {
  state = {
    activeVideo: 0,
    isVideoPaused: true,
    isHoldComplete: false,
    isHoldStarted: false,
    allInactive: false,
  };
  isReversing = false;
  activePlaylistIndex = 0;
  activeProgBar = 0;
  progressRefs = {};
  playlistData = this.props.sectionData.playlists;
  componentWillReceiveProps(nextProps) {
    if (this.props.preExit !== nextProps.preExit && nextProps.preExit) {
      // exit animation
      this.preDrawExit();
    }
    if (
      this.props.exitingDrawn !== nextProps.exitingDrawn &&
      nextProps.exitingDrawn
    ) {
      // exit animation
      this.postDrawExit();
    }
  }
  preDrawExit() {
    // fade out non-pixi content
    if (this.arrows) {
      TweenLite.to(this.arrows, 0.5, { opacity: 0 });
    }
    TweenLite.to('.playlist-slick', 0.5, { opacity: 0 });
    if (this.playlistData.length <= 2 && window.innerWidth > 800) {
      this.onCloseSection(0);
    } else {
      this.onCloseSection(this.activePlaylistIndex);
    }
  }
  postDrawExit() {
    TweenLite.set(this.container, { opacity: 0 });
  }
  bringBackUI = () => {
    const duration = 1.5;

    this.fadeInElements = new TimelineLite();

    this.fadeInElements
      .to('.maskDownLabel', duration, {
        y: 0,
        ease: Quart.easeInOut,
      })
      .to(
        '.fadeTitle .maskDownTitle',
        0.4,
        {
          opacity: 1,
          ease: Quart.easeInOut,
        },
        `-=${duration / 2}`
      )
      .to(
        '.fadeOut',
        duration / 2,
        {
          opacity: 1,
          ease: Quart.easeInOut,
        },
        `-=${duration}`
      )
      .to(
        '.slick-current .fadeOutWatermark',
        duration / 2,
        {
          opacity: 0.6,
          ease: Quart.easeInOut,
        },
        `-=${duration / 2}`
      )
      .to(
        [this.prevSlide, this.nextSlide],
        duration,
        {
          opacity: 1,
          ease: Linear.easeNone,
        },
        `-=${duration}`
      );

    if (this.getNumberOfSlides() === 2) {
      const buttonOff = this.container.querySelectorAll(
        '.js-storyInstructions'
      )[1 - this.activePlaylistIndex];

      this.fadeInElements.to(
        buttonOff,
        0.4,
        {
          opacity: 1,
          ease: Quart.easeInOut,
        },
        `-=${duration}`
      );
    }
    this.fadeInElements
      .to(
        'div:not(.fadeTitle) > div > .maskDownTitle',
        1.5,
        {
          y: 0,
          ease: Quart.easeInOut,
        },
        `-=${duration / 2}`
      )
      .to(
        '.scaleDown',
        0.8,
        {
          scale: 1,
          opacity: 1,
          ease: Back.easeIn,
        },
        `-=${duration / 3}`
      );

    TweenLite.to('.story-nav', 1, {
      opacity: 0,
      y: 0,
      ease: Back.easeOut,
    });
  };

  createProgressAnimation = () => {
    this.activeProgBar = this.activePlaylistIndex;
    if (this.lineDrawing) {
      this.lineDrawing.kill();
    }
    this.lineDrawing = new TimelineLite({
      paused: true,
    });
    this.lineDrawing
      .fromTo(
        `.progressBar${this.activeProgBar}`,
        1.5,
        {
          drawSVG: '0%',
          ease: Sine.easeInOut,
          delay: 2.0,
        },
        {
          drawSVG: '100%',
          ease: Sine.easeInOut,
        }
      )
      .eventCallback(
        'onComplete'
        // TODO: Figure out how to trigger on animation complete
        // Currently this fires on reverse complete
        // this.holdIsComplete();
      );
  };

  createFadeElementsTimeline = () => {
    const duration = 1.5;
    if (this.fadeOutElements) {
      this.fadeOutElements.kill();
    }
    this.fadeOutElements = new TimelineLite({
      paused: true,
    });
    this.fadeOutElements
      .to('.maskDownLabel', duration, {
        y: 50,
        ease: Quart.easeInOut,
      })
      .to(
        '.fadeTitle .maskDownTitle',
        0.4,
        {
          opacity: 0,
          ease: Quart.easeInOut,
        },
        `-=${duration}`
      )
      .to(
        '.fadeOut',
        duration / 2,
        {
          opacity: 0,
          ease: Quart.easeInOut,
        },
        `-=${duration}`
      )
      .to(
        '.fadeOutWatermark',
        duration / 2,
        {
          opacity: 0,
          ease: Quart.easeInOut,
        },
        `-=${duration}`
      )
      .to(
        [this.prevSlide, this.nextSlide],
        duration,
        {
          opacity: 0,
          ease: Linear.easeNone,
        },
        `-=${duration}`
      );
    if (this.getNumberOfSlides() === 2) {
      const buttonOff = this.container.querySelectorAll(
        '.js-storyInstructions'
      )[1 - this.activePlaylistIndex];

      this.fadeOutElements.to(
        buttonOff,
        0.4,
        {
          opacity: 0,
          ease: Quart.easeInOut,
        },
        `-=${duration}`
      );
    }
    this.fadeOutElements
      .to(
        'div:not(.fadeTitle) > div > .maskDownTitle',
        1.5,
        {
          y: 100,
          ease: Quart.easeInOut,
        },
        '-=1.35'
      )
      .to(
        '.scaleDown',
        0.8,
        {
          scale: 0,
          opacity: 0,
          ease: Back.easeIn,
        },
        '-=0.1'
      )
      .to(
        '.story-nav',
        1,
        {
          opacity: 1,
          y: 0,
          ease: Back.easeOut,
        },
        '-=0.1'
      );
  };

  holdIsComplete = () => {
    this.setState({
      isHoldComplete: true,
    });

    // hide header on mobile
    if (window.innerWidth < 768) {
      TweenLite.to('.site-header', 0.8, {
        opacity: 0,
        ease: Circ.easeInOut,
      });
      const header = document.querySelector('.site-header');
      header.style.pointerEvents = 'none';
      const dropdown = Array.from(document.querySelectorAll('.js-dropdownNav'));
      if (dropdown) {
        dropdown.forEach(dd => {
          dd.style.pointerEvents = 'none';
        });
      }
    }

    this.props.setPlaylistOpen(true);

    TweenLite.to('.back-to-chapter', 0.8, {
      opacity: 1,
      ease: Circ.easeInOut,
      delay: 0.3,
    });
  };

  getNextSlide = () => {
    this.nextSlide = this.currentSlide.nextElementSibling;
    if (this.nextSlide) {
      const title = this.nextSlide.querySelector('.splitText');
      title.classList.add('fadeTitle');

      this.nextImage =
        this.nextSlide !== null ? this.nextSlide.querySelector('img') : null;
    }
  };

  getPrevSlide = () => {
    this.prevSlide = this.currentSlide.previousElementSibling;
    if (this.prevSlide) {
      const title = this.prevSlide.querySelector('.splitText');
      title.classList.add('fadeTitle');

      this.prevImage =
        this.prevSlide !== null ? this.prevSlide.querySelector('img') : null;
    }
  };

  getCurrentSlideDOM(event) {
    const eventTarget = event.target;
    if (this.getNumberOfSlides() === 1) {
      return {
        el: document.querySelector('.playlist-slick .slick-slide'),
        index: 0,
      };
    } else if ((this.getNumberOfSlides() === 2) & (window.innerWidth > 800)) {
      // Find event target within Press-n-Play
      const target = findButton(eventTarget);
      const currentSection = document.querySelector('.fp-section.active');

      // Get current index and check if the target matches the intended target
      const playlistButtons = Array.from(
        currentSection.querySelectorAll('.playlist-button')
      );
      const currIndex = playlistButtons.findIndex(element => {
        return element === target;
      });

      this.setActivePlaylist(currIndex);

      // Set current slide to mousedown target
      return {
        el: document.querySelectorAll('.fp-section.active .slick-slide')[
          currIndex
        ],
        index: currIndex,
      };
    } else {
      return {
        el: document.querySelector('.fp-section.active .slick-current'),
        index: this.activePlaylistIndex,
      };
    }
  }

  resetFadeTitles() {
    const titles = Array.from(document.querySelectorAll('.fadeTitle'));
    titles.forEach(title => {
      if (title.classList) {
        title.classList.remove('fadeTitle');
      }
    });
  }

  handleMouseDown = event => {
    this.isReversing = false;
    event.preventDefault();
    event.stopPropagation();
    this.cancelHoldTimer = setTimeout(this.holdIsComplete, holdTimer);
    const current = this.getCurrentSlideDOM(event);
    this.currentSlide = current.el;
    this.resetFadeTitles();

    // Update next and previous slides based on current slide
    // Also sets fade title
    this.currentImage = this.currentSlide.querySelector('img');
    this.getNextSlide();
    this.getPrevSlide();
    this.createProgressAnimation();
    this.createFadeElementsTimeline();

    this.lineDrawing.play();
    this.onOpenSlide(current.index);
    this.fadeOutElements.play();

    // not sure we need these checks anymore

    // if (
    //   !this.lineDrawing ||
    //   this.lineDrawing.progress() === 1 ||
    //   this.activeProgBar !== this.state.activePlaylistIndex
    // ) {
    //   this.createProgressAnimation();
    // }

    // if (
    //   !this.fadeOutElements ||
    //   this.fadeOutElements.progress() === 1 ||
    //   this.activeProgBar !== this.state.activePlaylistIndex
    // ) {
    //   this.createFadeElementsTimeline();
    // }
  };

  handleMouseUp = event => {
    event.preventDefault();
    event.stopPropagation();
    if (this.isReversing) {
      return;
    }
    this.isReversing = true;
    this.setState({
      isHoldComplete: false,
    });

    clearTimeout(this.cancelHoldTimer);

    if (this.state.isHoldComplete === false && !this.lineDrawing.reversed()) {
      this.onCloseSlide();
      this.lineDrawing.reverse();
      this.fadeOutElements.reverse();
    }
  };

  onChapterClose = () => {
    TweenLite.to('.js-dropdownNav, .js-navItemActive', 0.8, {
      opacity: 1,
      ease: Circ.easeInOut,
    });
    // hide header on mobile
    if (window.innerWidth < 768) {
      TweenLite.to('.site-header', 0.8, {
        opacity: 1,
        ease: Circ.easeInOut,
      });
      const header = document.querySelector('.site-header');
      header.style.pointerEvents = 'auto';
      const dropdown = document.querySelectorAll('.js-dropdownNav');
      if (dropdown) {
        dropdown.forEach(dd => {
          dd.style.pointerEvents = 'auto';
        });
      }
    }

    this.resetProgress();
    this.props.setPlaylistOpen(false);
    this.setState({
      isHoldComplete: false,
      isVideoPaused: true,
    });

    // this.fadeOutElements.timeScale(1.25).reverse();
    this.bringBackUI();

    this.onCloseSlide();
    TweenLite.to('.back-to-chapter', 0.8, {
      opacity: 0,
      ease: Circ.easeInOut,
      delay: 0.3,
    });
    setTimeout(() => {
      this.setState({
        activeVideo: 0,
      });
    }, 1500);
  };

  registerProgressBar = (elem, index) => {
    this.progressRefs[index] = elem;
  };

  onVideoComplete = () => {
    if (
      this.state.activeVideo <
      this.props.sectionData.playlists[this.activePlaylistIndex].slides.length -
        1
    ) {
      this.setState(state => ({
        activeVideo: state.activeVideo + 1,
      }));
    } else if (
      this.state.activeVideo ===
      this.props.sectionData.playlists[this.activePlaylistIndex].slides.length -
        1
    ) {
      this.onChapterClose();
    }
  };

  handlePlayPause = () => {
    this.setState(state => ({
      isVideoPaused: !state.isVideoPaused,
    }));
  };

  goToVideo = activeVideo => {
    this.setState({
      activeVideo: activeVideo,
    });
  };

  setActivePlaylist = index => {
    this.activePlaylistIndex = index;
    this.props.setActiveImage(
      this.props.index,
      this.playlistData[this.activePlaylistIndex].image.sizes.large
    );
  };

  skipVideo = direction => {
    if (direction === 'prev' && this.state.activeVideo > 0) {
      this.setState(state => ({
        activeVideo: state.activeVideo - 1,
      }));
    } else if (
      direction === 'next' &&
      this.state.activeVideo <
        this.props.sectionData.playlists[0].slides.length - 1
    ) {
      this.setState(state => ({
        activeVideo: state.activeVideo + 1,
      }));
    }
  };

  isActivePlaylist = index => {
    if (this.playlistData.length <= 2 && !this.state.allInactive) {
      return style.activePlaylist;
    } else {
      return this.activePlaylistIndex === index && !this.state.allInactive
        ? style.activePlaylist
        : style.inactivePlaylist;
    }
  };

  getNumberOfSlides = () => {
    if (this.playlistData.length < 2) {
      return 1;
    } else if (this.playlistData.length > 2) {
      return 3;
    } else {
      return 2;
    }
  };

  registerNextListener = func => {
    this.onNextSlide = func;
  };
  registerPrevListener = func => {
    this.onPrevSlide = func;
  };
  registerOpenListener = func => {
    this.onOpenSlide = func;
  };
  registerCloseListener = func => {
    this.onCloseSlide = func;
  };
  registerCloseSectionListener = func => {
    this.onCloseSection = func;
  };
  resetProgress = () => {
    TweenLite.set('.view-button-progress', {
      drawSVG: '0%',
    });
  };
  componentDidMount() {
    if (this.props.setActiveImage) {
      this.props.setActiveImage(
        this.props.index,
        this.playlistData[this.activePlaylistIndex].image.sizes.large
      );
    }

    if (typeof window !== 'undefined') {
      SplitText = require('../../lib/SplitText');
      DrawSVG = require('../../lib/DrawSVG');
    }
    this.resetProgress();
    this.startCurrentUI();
    window.addEventListener('resize', this.addCurrentUI);
    let splitWords;
    const splitText = new SplitText('.splitText', {
      type: 'words',
      wordsClass: 'maskDownTitle',
    });

    if (typeof document !== 'undefined') {
      splitWords = document.querySelectorAll('.maskDownTitle');
    }

    const wrap = (el, wrapper) => {
      el.parentNode.insertBefore(wrapper, el);
      wrapper.appendChild(el);
    };

    splitWords.forEach(word => {
      let element;
      if (typeof document !== 'undefined') {
        element = document.createElement('div');
      }
      element.className = style.maskDownWrapper;
      wrap(word, element);
    });
  }

  startCurrentUI() {
    const numSlides = this.getNumberOfSlides();
    let slideSelector;
    if (numSlides === 2) {
      slideSelector = '.slick-slide';
    } else {
      slideSelector = ".slick-slide[data-index='0']";
    }

    const title = this.container.querySelectorAll(
      `${slideSelector} .js-storyTitle`
    );
    TweenLite.set(title, {
      scale: window.innerWidth <= 800 ? 1.1 : 1.35,
      opacity: 1,
    });
    const water = this.container.querySelectorAll(
      `${slideSelector} .chapter-watermark`
    );
    TweenLite.set(water, {
      opacity: 0.6,
    });
    const instructions = this.container.querySelectorAll(
      `${slideSelector} .js-storyInstructions`
    );
    TweenLite.set(instructions, {
      opacity: 1,
    });
  }
  addCurrentUI = () => {
    let currentSlideString = '.fp-section.active .slick-center';
    if ((this.getNumberOfSlides() === 2) & (window.innerWidth > 800)) {
      currentSlideString = '.fp-section.active .slick-slide';
    }

    TweenLite.to(`${currentSlideString} .js-storyTitle`, 0.75, {
      scale: window.innerWidth <= 800 ? 1.1 : 1.35,
      opacity: 1,
    });
    TweenLite.to(`${currentSlideString} .chapter-watermark`, 0.75, {
      opacity: 0.6,
    });
    TweenLite.to(`${currentSlideString} .js-storyInstructions`, 0.75, {
      opacity: 1,
    });
  };
  removeCurrentUI() {
    const currentSlideString = '.fp-section.active .slick-center';
    TweenLite.to(`${currentSlideString} .js-storyTitle`, 0.75, {
      scale: 1,
      opacity: 0.4,
    });
    TweenLite.to(`${currentSlideString} .chapter-watermark`, 0.75, {
      opacity: 0,
    });
    TweenLite.to(`${currentSlideString} .js-storyInstructions`, 0.75, {
      opacity: 0,
    });
  }

  handleNextSlide = () => {
    if (this.isSliding || !this.onNextSlide) {
      return;
    }
    this.removeCurrentUI();
    this.slider.slickNext();
    setTimeout(() => {
      this.addCurrentUI();
    }, 250);
    this.onNextSlide();
  };

  handlePrevSlide = () => {
    if (this.isSliding || !this.onPrevSlide) {
      return;
    }
    this.removeCurrentUI();
    this.slider.slickPrev();
    setTimeout(() => {
      this.addCurrentUI();
    }, 250);
    this.onPrevSlide();
  };

  componentWillUnmount() {
    window.removeEventListener('resize', this.addCurrentUI);
    if (!this.props.isChapter) {
      this.props.setPlaylistOpen(false);
      this.setState({
        isHoldComplete: false,
        isVideoPaused: true,
        activeVideo: 0,
      });
    }
  }

  renderArrows() {
    if (typeof window === 'undefined') {
      return <div />;
    }
    const numSlides = this.getNumberOfSlides();

    if (numSlides === 3 || (numSlides === 2 && window.innerWidth <= 800)) {
      return (
        <div
          ref={el => {
            this.arrows = el;
          }}
        >
          <div className={`fadeOut ${style.arrowWrapRight}`}>
            <ArrowButton
              onClick={this.handleNextSlide}
              direction={'right'}
              white
            />
          </div>
          <div className={`fadeOut ${style.arrowWrap}`}>
            <ArrowButton
              onClick={this.handlePrevSlide}
              direction={'left'}
              white
            />
          </div>
        </div>
      );
    } else {
      return <div />;
    }
  }

  render() {
    const { activeVideo, isHoldComplete, isVideoPaused } = this.state;
    const { screenOrientation, isPlaylistOpen } = this.props;
    const currentPlaylist = this.playlistData[this.activePlaylistIndex];
    const numSlides = this.getNumberOfSlides();
    const slickOptions = {
      dots: false,
      infinite: true,
      arrows: false,
      centerMode: numSlides === 3,
      slidesToShow: numSlides === 2 ? 2 : 1,
      centerPadding: numSlides === 3 ? '32%' : 0,
      draggable: false,
      swipe: false,
      speed: 1000,
      respondTo: 'window',
      cssEase: 'cubic-bezier(0.5, 0, 0.5, 1)',
      responsive: [
        {
          breakpoint: 800,
          settings: {
            draggable: false,
            slidesToShow: 1,
            centerMode: true,
            centerPadding: 0,
          },
        },
      ],
      beforeChange: () => {
        this.isSliding = true;
      },
      afterChange: index => {
        this.isSliding = false;
        this.setActivePlaylist(index);
        this.setState({ allInactive: false });
      },
    };
    return (
      <div
        className={`section ${style.sectionWrapper}`}
        ref={el => {
          this.container = el;
        }}
      >
        {this.props.isCurrentSlide &&
          !isPlaylistOpen && (
            <SwipeNextPrev
              next={this.handleNextSlide}
              prev={this.handlePrevSlide}
            />
          )}
        {this.props.isChapter && (
          <BackToChapterButton
            isPlaylistOpen={isPlaylistOpen}
            onChapterClose={this.onChapterClose}
          />
        )}
        {this.renderArrows()}

        <Slider
          ref={el => {
            this.slider = el;
          }}
          className={`playlist-slick ${style.playlistWrapper}`}
          {...slickOptions}
        >
          {this.playlistData.map((playlist, index) => (
            <PlaylistCoverText
              key={playlist.title}
              isActive={this.isActivePlaylist(index)}
              isPlaylistOpen={isPlaylistOpen}
              playlist={playlist}
              index={index}
              handleMouseDown={this.handleMouseDown}
              handleMouseUp={this.handleMouseUp}
              registerProgressBar={this.registerProgressBar}
              disallowScroll={this.props.disallowScroll}
              allowScroll={this.props.allowScroll}
            />
          ))}
        </Slider>

        <ImageSlider
          display={
            typeof this.props.display !== 'undefined'
              ? this.props.display
              : true
          }
          images={this.playlistData.map(data => data.image)}
          registerNextListener={this.registerNextListener}
          registerPrevListener={this.registerPrevListener}
          registerOpenListener={this.registerOpenListener}
          registerCloseListener={this.registerCloseListener}
          registerCloseSectionListener={this.registerCloseSectionListener}
        />

        <PlaylistGesturalNavigation
          activeVideo={activeVideo}
          isPlaylistOpen={isPlaylistOpen}
          navigateVideos={this.skipVideo}
        />

        <StoryProgressBar
          activeVideo={activeVideo}
          isVideoPaused={isVideoPaused}
          isPlaylistOpen={isPlaylistOpen}
          playlistVideoData={currentPlaylist.slides}
          onPlayPauseClick={this.handlePlayPause}
          navigateVideos={this.goToVideo}
        />

        <PlaylistVideo
          activeVideo={activeVideo}
          isVideoPaused={isVideoPaused}
          isPlaylistOpen={isPlaylistOpen}
          screenOrientation={screenOrientation}
          playlistVideoData={currentPlaylist.slides}
          togglePlayPause={this.handlePlayPause}
          videoEnded={this.onVideoComplete}
        />
      </div>
    );
  }
}

export default ChapterSectionPressPlay;



// WEBPACK FOOTER //
// ./src/components/chapter/ChapterSectionPressPlayPixi.js